function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { convertSiteLevelMetaTags } from '../../converters/convert-site-level-meta-tags';
import { getUserPatternByItemType } from '../../patterns/get-user-pattern-by-item-type';
import { getContext } from '../../tags/context/get-context';
import { ITEM_TYPES } from '../../types/ItemTypes';
import { filterPageLevelTags } from '../../tags/filters/filter-page-level-tags';
import { getAdapter } from '../../adapters';
import { convertSeoModel } from '../../converters/convert-seo-model';
import { getPatternBlob } from '../../patterns';
import { resolveWithPatterns } from '../resolve-with-patterns';
import { getDefaultItemPayload } from '../../patterns/get-default-item';
import { handleOldBlog } from '../../item-types/blog/blog-post/handleOldBlogPost/handle-old-blog-post';
import { CONTEXT_PROPS } from '../../types/ContextProps';

function _getEditorPayload(context, pageLevelSeoData) {
  var editorPanelLegacyData = getAdapter(ITEM_TYPES.STATIC_PAGE_V2).getLegacySeoBlob({
    context: context
  });
  var editorPanelPageData = convertSeoModel(pageLevelSeoData.advancedSeoData);
  return [editorPanelLegacyData, editorPanelPageData];
}

function _getDefaultPatternsSchemas(siteLevelSeoData, itemType) {
  var defaultStaticPatternSchema = getPatternBlob(ITEM_TYPES.STATIC_PAGE_V2);
  var defaultItemTypePatternSchema = getPatternBlob(itemType);
  return [defaultStaticPatternSchema, defaultItemTypePatternSchema];
}

export function getTags(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$siteLevelSeoData = _ref.siteLevelSeoData,
      siteLevelSeoData = _ref$siteLevelSeoData === void 0 ? {} : _ref$siteLevelSeoData,
      _ref$pageLevelSeoData = _ref.pageLevelSeoData,
      pageLevelSeoData = _ref$pageLevelSeoData === void 0 ? {} : _ref$pageLevelSeoData,
      _ref$corvidOverrides = _ref.corvidOverrides,
      corvidOverrides = _ref$corvidOverrides === void 0 ? [] : _ref$corvidOverrides,
      _ref$corvidItemPayloa = _ref.corvidItemPayload,
      corvidItemPayload = _ref$corvidItemPayloa === void 0 ? getDefaultItemPayload() : _ref$corvidItemPayloa,
      _ref$dynamicPageData = _ref.dynamicPageData,
      dynamicPageData = _ref$dynamicPageData === void 0 ? [] : _ref$dynamicPageData,
      _ref$tpaSeoEndpointDa = _ref.tpaSeoEndpointData,
      tpaSeoEndpointData = _ref$tpaSeoEndpointDa === void 0 ? [] : _ref$tpaSeoEndpointDa,
      _ref$tpaOverrides = _ref.tpaOverrides,
      tpaOverrides = _ref$tpaOverrides === void 0 ? [] : _ref$tpaOverrides;

  var siteLevelMetaTags = filterPageLevelTags(convertSiteLevelMetaTags(siteLevelSeoData.metaTags));
  var itemType = corvidItemPayload.itemType,
      itemData = corvidItemPayload.itemData,
      seoData = corvidItemPayload.seoData,
      asNewPage = corvidItemPayload.asNewPage;
  var userPatternSchema = getUserPatternByItemType(siteLevelSeoData.userPatterns, itemType);
  var patternSchemas = [].concat(_getDefaultPatternsSchemas(siteLevelSeoData, itemType), [userPatternSchema]);
  var context = getContext(siteLevelSeoData, pageLevelSeoData, userPatternSchema);
  var adapter = getAdapter(itemType);
  var platformLegacySeoOverrides = adapter.getLegacySeoBlob(itemData);
  var platformSchemaOverrides = seoData;
  var platformPayload = context[CONTEXT_PROPS.CURR_LANG_IS_ORIGINAL] ? [platformLegacySeoOverrides, platformSchemaOverrides] : [platformSchemaOverrides, platformLegacySeoOverrides];

  var contextWithItemData = _objectSpread(_objectSpread({}, itemData), {}, {
    context: context
  });

  var payload = asNewPage ? [siteLevelMetaTags].concat(patternSchemas, platformPayload) : [siteLevelMetaTags].concat(patternSchemas, _getEditorPayload(context, pageLevelSeoData), [dynamicPageData, tpaSeoEndpointData, tpaOverrides], platformPayload, [corvidOverrides]);
  var adaptedContext = adapter.getData(contextWithItemData);
  var resolvedTags = resolveWithPatterns(payload, adaptedContext);
  return handleOldBlog(resolvedTags, siteLevelSeoData);
}